import _URL from '../../URL/index';
const axios = _URL.axios;
const limit = 10

export default {
    services: {
        getCustomersOptions: (token) => {
            return axios(token).post(`/dispatch/customers-options`)
        },
        createCustomer: (body, token) => {
            return axios(token).post(`/customers?origin=dispatch`, body);
        },
    }
}